import React from 'react';
import '../../styles/eneos.css';

const TermsOfService = () => {
  return (
    <div className="eneos-theme">
      <div className="eneos-container">
        <h1>Terms of Service</h1>
        <p className="page-info">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="info-box">
          <strong>Agreement:</strong> By accessing or using SoftLaabs services, you agree to be bound by these Terms of Service.
        </div>

        <h2>1. Acceptance of Terms</h2>
        <p>
          These Terms of Service ("Terms") govern your access to and use of SoftLaabs' services, including our website, software development services, and any related services (collectively, the "Services"). By using our Services, you agree to these Terms. If you do not agree, do not use our Services.
        </p>

        <h2>2. Description of Services</h2>
        <p>
          SoftLaabs provides custom software development services, including but not limited to:
        </p>
        <ul>
          <li>Web application development</li>
          <li>Mobile application development (iOS and Android)</li>
          <li>Desktop software development</li>
          <li>Digital transformation consulting</li>
          <li>System integration services</li>
          <li>Technical support and maintenance</li>
        </ul>

        <h2>3. User Accounts and Registration</h2>
        <p>
          To access certain Services, you may be required to create an account. You agree to:
        </p>
        <ul>
          <li>Provide accurate, current, and complete information</li>
          <li>Maintain and update your information to keep it accurate</li>
          <li>Maintain the security of your account credentials</li>
          <li>Accept responsibility for all activities under your account</li>
          <li>Notify us immediately of any unauthorized access</li>
        </ul>

        <h2>4. Service Agreements and Project Terms</h2>
        <p>
          Specific projects will be governed by separate written agreements that include:
        </p>
        <ul>
          <li>Project scope and deliverables</li>
          <li>Timeline and milestones</li>
          <li>Payment terms and pricing</li>
          <li>Intellectual property rights</li>
          <li>Confidentiality obligations</li>
          <li>Warranty and support terms</li>
        </ul>

        <div className="info-box warning">
          <strong>Important:</strong> Project-specific agreements take precedence over these general Terms of Service.
        </div>

        <h2>5. Payment Terms</h2>
        <p>
          Unless otherwise specified in a project agreement:
        </p>
        <ul>
          <li>Payment terms will be outlined in project proposals</li>
          <li>Invoices are due within 30 days of issuance</li>
          <li>Late payments may incur interest charges</li>
          <li>We reserve the right to suspend services for non-payment</li>
          <li>All fees are non-refundable unless otherwise stated</li>
        </ul>

        <h2>6. Intellectual Property Rights</h2>
        
        <h3>6.1 Client-Owned IP</h3>
        <p>
          Upon full payment, you will own the intellectual property rights to custom software developed specifically for you, subject to the terms of your project agreement.
        </p>

        <h3>6.2 SoftLaabs IP</h3>
        <p>
          We retain ownership of:
        </p>
        <ul>
          <li>Pre-existing tools, frameworks, and libraries</li>
          <li>General methodologies and processes</li>
          <li>Reusable code components and templates</li>
          <li>Our trademarks, logos, and brand materials</li>
        </ul>

        <h3>6.3 Third-Party IP</h3>
        <p>
          Projects may incorporate third-party software, libraries, or services subject to their respective licenses.
        </p>

        <h2>7. Confidentiality</h2>
        <p>
          Both parties agree to:
        </p>
        <ul>
          <li>Protect confidential information disclosed during the engagement</li>
          <li>Use confidential information only for the intended purpose</li>
          <li>Not disclose confidential information to third parties without consent</li>
          <li>Return or destroy confidential information upon request</li>
        </ul>

        <h2>8. Warranties and Disclaimers</h2>
        
        <h3>8.1 Our Warranties</h3>
        <p>
          We warrant that:
        </p>
        <ul>
          <li>Services will be performed in a professional and workmanlike manner</li>
          <li>Deliverables will substantially conform to agreed specifications</li>
          <li>We have the right to provide the Services</li>
        </ul>

        <h3>8.2 Disclaimer</h3>
        <p>
          EXCEPT AS EXPRESSLY PROVIDED, SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
        </p>

        <h2>9. Limitation of Liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW:
        </p>
        <ul>
          <li>Our total liability shall not exceed the fees paid for the specific service</li>
          <li>We are not liable for indirect, incidental, or consequential damages</li>
          <li>We are not liable for loss of profits, data, or business opportunities</li>
          <li>These limitations apply regardless of the legal theory of liability</li>
        </ul>

        <h2>10. Indemnification</h2>
        <p>
          You agree to indemnify and hold SoftLaabs harmless from any claims, damages, or expenses arising from:
        </p>
        <ul>
          <li>Your use of our Services</li>
          <li>Your violation of these Terms</li>
          <li>Your violation of any third-party rights</li>
          <li>Content or data you provide to us</li>
        </ul>

        <h2>11. Term and Termination</h2>
        
        <h3>11.1 Term</h3>
        <p>
          These Terms remain in effect while you use our Services.
        </p>

        <h3>11.2 Termination</h3>
        <p>
          Either party may terminate a project agreement:
        </p>
        <ul>
          <li>For convenience with written notice as specified in the agreement</li>
          <li>Immediately for material breach by the other party</li>
          <li>Immediately if the other party becomes insolvent</li>
        </ul>

        <h3>11.3 Effect of Termination</h3>
        <p>
          Upon termination:
        </p>
        <ul>
          <li>You must pay for all services rendered up to the termination date</li>
          <li>We will deliver completed work as specified in the agreement</li>
          <li>Confidentiality obligations continue</li>
          <li>Provisions that by nature should survive will remain in effect</li>
        </ul>

        <h2>12. Acceptable Use Policy</h2>
        <p>
          You agree not to:
        </p>
        <ul>
          <li>Use our Services for any illegal purpose</li>
          <li>Violate any applicable laws or regulations</li>
          <li>Infringe on intellectual property rights</li>
          <li>Transmit malicious code or harmful content</li>
          <li>Interfere with or disrupt our Services</li>
          <li>Attempt unauthorized access to our systems</li>
        </ul>

        <h2>13. Modifications to Services and Terms</h2>
        <p>
          We reserve the right to:
        </p>
        <ul>
          <li>Modify or discontinue Services with reasonable notice</li>
          <li>Update these Terms from time to time</li>
          <li>Notify you of material changes via email or website notice</li>
        </ul>

        <h2>14. Dispute Resolution</h2>
        
        <h3>14.1 Negotiation</h3>
        <p>
          Parties agree to first attempt to resolve disputes through good-faith negotiation.
        </p>

        <h3>14.2 Arbitration</h3>
        <p>
          If negotiation fails, disputes will be resolved through binding arbitration in accordance with applicable arbitration rules.
        </p>

        <h3>14.3 Governing Law</h3>
        <p>
          These Terms are governed by the laws of the jurisdiction where SoftLaabs operates, without regard to conflict of law principles.
        </p>

        <h2>15. General Provisions</h2>
        
        <h3>15.1 Entire Agreement</h3>
        <p>
          These Terms, together with any project-specific agreements, constitute the entire agreement between the parties.
        </p>

        <h3>15.2 Severability</h3>
        <p>
          If any provision is found unenforceable, the remaining provisions remain in full effect.
        </p>

        <h3>15.3 Waiver</h3>
        <p>
          Failure to enforce any provision does not constitute a waiver of that provision.
        </p>

        <h3>15.4 Assignment</h3>
        <p>
          You may not assign these Terms without our written consent. We may assign these Terms without restriction.
        </p>

        <h2>16. Contact Information</h2>
        <p>
          For questions about these Terms, please contact us:
        </p>
        <div className="info-box">
          <strong>Email:</strong> <a href="mailto:softlaabs@softlaabs.org">softlaabs@softlaabs.org</a><br />
          <strong>Phone:</strong> +254 792560128<br />
          <strong>Address:</strong> Remote Services Worldwide
        </div>

        <hr />

        <p style={{ fontSize: '13px', color: '#50575e', marginTop: '2em' }}>
          By using SoftLaabs services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
        </p>

        <div style={{ marginTop: '2em' }}>
          <button className="eneos-btn">Download PDF</button>
          {' '}
          <button className="eneos-btn secondary">Print Terms</button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
